"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FilterItemStyled = require("./FilterItem-styled.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = _interopRequireDefault(require("../FilterItemOption/index.js"));
var _stateTypes = _interopRequireDefault(require("../../store/stateTypes"));
var _CustomDateRange = _interopRequireDefault(require("../CustomDateRange"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FilterItem = function FilterItem(_ref) {
  var _ref$item = _ref.item,
    id = _ref$item.id,
    title = _ref$item.title,
    itemOptions = _ref$item.itemOptions,
    state = _ref$item.state,
    startDate = _ref$item.startDate,
    endDate = _ref$item.endDate,
    onChangeFilter = _ref.onChangeFilter,
    onFilterItemClick = _ref.onFilterItemClick,
    onFilterItemOptionClick = _ref.onFilterItemOptionClick,
    filters = _ref.filters;
  var active = state === _stateTypes.default.FILTER_ITEM_ACTIVE;
  var disabled = state === _stateTypes.default.FILTER_ITEM_DISABLED;
  var isCustomRange = id.split("-")[0] === "custom";
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FilterItemStyled.StyledFilterItem, {
    active: active,
    disabled: disabled,
    onClick: function onClick() {
      return onFilterItemClick(id);
    }
  }, /*#__PURE__*/_react.default.createElement(_FilterItemStyled.StyledListItemTitle, null, title)), active && isCustomRange ? /*#__PURE__*/_react.default.createElement(_CustomDateRange.default, {
    item: {
      id: id,
      startDate: startDate,
      endDate: endDate
    },
    onChangeFilter: onChangeFilter,
    filters: filters
  }) : active && !isCustomRange && /*#__PURE__*/_react.default.createElement(_FilterItemStyled.StyledFilterItemOptionList, {
    minimal: true,
    nested: true,
    open: active,
    style: {
      maxWidth: "20rem"
    }
  }, itemOptions.map(function (itemOption) {
    return /*#__PURE__*/_react.default.createElement(_index.default, {
      key: itemOption.id,
      itemOption: itemOption,
      onFilterItemOptionClick: onFilterItemOptionClick
    });
  })));
};
FilterItem.propTypes = {
  item: _propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired,
    state: _propTypes.default.string.isRequired
  }),
  onChangeFilter: _propTypes.default.func,
  onFilterItemClick: _propTypes.default.func,
  onFilterItemOptionClick: _propTypes.default.func,
  filters: _propTypes.default.shape({
    groups: _propTypes.default.shape({
      byId: _propTypes.default.shape({
        id: _propTypes.default.string,
        title: _propTypes.default.string,
        state: _propTypes.default.string
      }),
      allIds: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
    }),
    items: _propTypes.default.shape({
      byId: _propTypes.default.shape({
        id: _propTypes.default.string,
        title: _propTypes.default.string,
        state: _propTypes.default.string,
        group: _propTypes.default.string
      }),
      allIds: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
    }),
    itemOptions: _propTypes.default.shape({
      byId: _propTypes.default.shape({
        id: _propTypes.default.string,
        title: _propTypes.default.string,
        state: _propTypes.default.string,
        group: _propTypes.default.string
      }),
      allIds: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
    })
  }).isRequired
  // startDate:,
  // endDate:
};
var _default = FilterItem;
exports.default = _default;